import React, { useRef, useEffect, useCallback } from 'react';
import { VideoManagementDemo } from '../../../VideoManagement/';
import { IVideoManager } from '../../../VideoManagement/VideoManagementDemo';

interface OfficialSelectionMenuProps {
    contestId: string;
    open: boolean;
    onClose: () => void;
}

export const OfficialSelectionMenu: React.FC<OfficialSelectionMenuProps> = ({ contestId, open, onClose }) => {
    const ref = useRef<IVideoManager | null>(null);
    const [key, setKey] = React.useState(0);

    const handleOpenModal = useCallback(() => {
        if (ref.current) {
            ref.current.openModal();
        }
    }, []);

    useEffect(() => {
        if (open) {
            // Force re-render of VideoManagementDemo to reset its internal state
            setKey(prev => prev + 1);
            // Small delay to ensure the component is re-rendered before opening
            setTimeout(() => {
                handleOpenModal();
            }, 100);
        } else {
        }
    }, [open, handleOpenModal]);

    return (
        <>
            <VideoManagementDemo key={key} contestId={contestId} ref={ref} />
        </>
    );
};
